export function injectTokensFromHash(): void {
    const hash = window.location.hash;

    if (!hash.startsWith('#tokens=')) {
        return;
    }

    try {
        const encoded = hash.substring('#tokens='.length);
        const tokens: Record<string, string> = JSON.parse(atob(encoded));

        Object.entries(tokens).forEach(([key, value]) => {
            localStorage.setItem(key, value);
        });

        history.replaceState(null, '', window.location.pathname + window.location.search);
    } catch {
        // ignore malformed token data
    }
}
